import React from 'react';
import styled from 'styled-components';
import { SRLWrapper } from 'simple-react-lightbox';
import { Link } from 'react-router-dom';

const ThemedDiv = styled.div`
  background: ${({ theme }) => theme.bg3};
  color: ${({ theme }) => theme.textColor};
`;

const FrontEnd = () => {
  return (
    <ThemedDiv>
      <div id='frontend' className='container pt-5 pb-5'>
        <h2 className='heading-lg'>front-end project features</h2>
        <SRLWrapper
          options={{
            settings: {
              autoplaySpeed: 5000,
            },
          }}
        >
          <div className='lightbox'>
            <div className='lightbox-slide col-lg-5 col-md-10'>
              <div
                className=' uk-inline-clip uk-transition-toggle'
                tabindex='0'
              >
                <a href='slides/validated.png' data-caption='Validated'>
                  <img src='slides/validated.png' alt='' />
                  <div class='uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default'>
                    <p class='uk-h4 uk-margin-remove uk-text-center lightbox-title'>
                      click to enlarge
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div className='lightbox-slide col-lg-5 col-md-10'>
              <div
                className=' uk-inline-clip uk-transition-toggle'
                tabindex='0'
              >
                <a href='slides/responsive.png' data-caption='Responsive'>
                  <img src='slides/responsive.png' alt='' />
                  <div class='uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default'>
                    <p class='uk-h4 uk-margin-remove uk-text-center lightbox-title'>
                      click to enlarge
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div className='lightbox-slide col-lg-5 col-md-10'>
              <div
                className=' uk-inline-clip uk-transition-toggle'
                tabindex='0'
              >
                <a href='slides/layouts.png' data-caption='Layouts'>
                  <img src='slides/layouts.png' alt='' />
                  <div class='uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default'>
                    <p class='uk-h4 uk-margin-remove uk-text-center lightbox-title'>
                      click to enlarge
                    </p>
                  </div>
                </a>
              </div>
            </div>
            <div className='lightbox-slide col-lg-5 col-md-10'>
              <div
                className=' uk-inline-clip uk-transition-toggle'
                tabindex='0'
              >
                <a href='slides/api.png' data-caption='API'>
                  <img src='slides/api.png' alt='' />
                  <div class='uk-transition-slide-bottom uk-position-bottom uk-overlay uk-overlay-default'>
                    <p class='uk-h4 uk-margin-remove uk-text-center lightbox-title'>
                      click to enlarge
                    </p>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </SRLWrapper>
        <div className='d-flex justify-content-end mt-5'>
          <Link to='/projects' className='link-to'>
            <span
              style={{
                color: '#69A1AC',
                textShadow: '1px 1px #2F3676',
                letterSpacing: '2px',
              }}
            >
              See all projects --->>
            </span>
          </Link>
        </div>
      </div>
    </ThemedDiv>
  );
};

export default FrontEnd;
